const apiUrls = require('../../constants/apiUrls');

const collectionDetails = {
    key: 'collectionDetails',
    method: 'GET',
    getApiUrl: (request) => {
        return `${apiUrls.WORKORDER_CUSTOMER_COLLECTION_URL}?billingSystem=${request.billingSystem}&accountNumber=${request.accountNumber}`;
    },
    dependencies: [
        {
            key: 'orderDetails',
            requestProps: [
                {
                    path: [
                        'details', 'accountNumber'
                    ],
                    propName: 'accountNumber'
                }
            ]
        }, {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'billingSystem'
                    ],
                    propName: 'billingSystem'
                }, {
                    path: [
                        'details', 'marketId'
                    ],
                    propName: 'marketId'
                }
            ]
        }
    ]
};

export default collectionDetails;


// WEBPACK FOOTER //
// ./src/store/order-details-config/collectionDetails.js